import { combineReducers } from 'redux';

import uiReducer from './ui/ui.slice';
import hyperlinkReducer from './hyperlinks/hyperlinks.slice';

export default  combineReducers({
  hyperlink: hyperlinkReducer,
  ui: uiReducer
});